import styled from 'styled-components';

export const AppContainer = styled.div`
  overflow: auto;
  padding-top: 60px;
  padding-bottom: 40px;

  @media (${({ theme }) => theme.MEDIA_MIN.tablet}) {
    padding-bottom: 0;
  }
`;

export const AlertsContainer = styled.div`
  position: absolute;
  top: 0;
  min-width: fit-content;
  left: 50%;
  transform: translateX(-50%);
  z-index: 20;
  justify-content: center;
  display: flex;
  align-items: center;
`;
